import { Paper, Typography, Box, Button, TextField } from "@mui/material";
import { useStyles } from "./login-form-style";
 
import LoginFormContents  from "./LoginFormContents";



const LoginForm = () => {
  const classes = useStyles();
 
  return (
    <Paper className={classes.bgPaper} elevation={0}>
      <Typography className={classes.formHeader}>Login</Typography>
      <Typography className={classes.formDesc}>
        Welcome back! Log in to your account.
      </Typography>

      <LoginFormContents />
    </Paper>
  );
};

export default LoginForm;
